export const CONTACT_OWNER_OPTION = { value: -1, label: "Contact's Owner" };
